






































import Vue from "vue";
import Component from "vue-class-component";
import { config } from "@/config";
import { Watch } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";

@Component({
    components: {
        Modal,
    },
})
export default class App extends Vue {
    private isOpen: boolean = false;
    private isHome: boolean = true;
    private isGenerating: boolean = false;
    private network: string | null = null;

    @Watch("$route")
    public onPropertyChanged(value: string, oldValue: string): void {
        this.isHomeRoute();
        this.isEntropyRoute();
    }

    public backToHome(): void {
        this.$router.push({ name: "home" });
    }

    public openSettings(): void {
        this.isOpen = true;
    }

        public closeSettings(): void {
        this.isOpen = false;
    }

    private isHomeRoute(): void {
        this.isHome = this.$router.currentRoute.name === "home";
    }

    private isEntropyRoute(): void {
        this.isGenerating = this.$router.currentRoute.name === "entropy";
    }
}
